import { useNavigate } from 'react-router-dom';

export default function DescargarApp() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-blue-900 text-white">
      {/* Header */}
      <header className="px-6 py-4 flex items-center justify-between border-b border-white/10">
        <div className="flex items-center gap-3">
          <img
            src="/logo.png"
            alt="Lluchunga"
            className="w-12 h-12 rounded-full bg-white/90 p-1"
            style={{ objectFit: 'contain' }}
            onError={(e) => { e.currentTarget.style.display = 'none'; }}
          />
          <div>
            <div className="text-xl font-bold leading-tight">Lluchunga</div>
            <div className="text-[10px] tracking-widest uppercase text-blue-200">
              Soporte Tecnológico
            </div>
          </div>
        </div>
        <button
          onClick={() => navigate('/login')}
          className="px-4 py-2 text-sm border border-white/30 rounded-lg hover:bg-white/10 transition"
        >
          Iniciar sesión →
        </button>
      </header>

      {/* Hero */}
      <div className="max-w-5xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">

          {/* Izquierda: Texto */}
          <div>
            <div className="inline-block bg-amber-400 text-amber-900 px-3 py-1 rounded-full text-xs font-bold mb-4">
              📱 APP MÓVIL
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4 leading-tight">
              Descarga la app y gestiona tu finca desde el campo
            </h1>
            <p className="text-blue-100 text-base mb-6 leading-relaxed">
              Registra muestreos, parámetros de calidad de agua, alertas de alimentación
              y mucho más, incluso sin internet. Sincroniza automáticamente al recuperar conexión.
            </p>

            {/* Beneficios */}
            <ul className="space-y-3 mb-8">
              <li className="flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-green-500/20 text-green-300 flex items-center justify-center">✓</span>
                <span className="text-sm">Funciona <strong>offline</strong>, sincroniza al recuperar conexión</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-green-500/20 text-green-300 flex items-center justify-center">✓</span>
                <span className="text-sm">Registra <strong>pesos y prepesos</strong> de camarón</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-green-500/20 text-green-300 flex items-center justify-center">✓</span>
                <span className="text-sm">Monitorea <strong>oxígeno y temperatura</strong> en tiempo real</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-green-500/20 text-green-300 flex items-center justify-center">✓</span>
                <span className="text-sm">Instala equipos con <strong>GPS preciso</strong></span>
              </li>
            </ul>

            {/* Botón de descarga */}
            <a
              href="/app-release.apk"
              download
              className="inline-flex items-center gap-3 px-8 py-4 bg-white text-slate-900 rounded-2xl font-bold text-lg shadow-2xl hover:shadow-3xl hover:scale-105 transition"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.523 15.3414c-.5511 0-.9993-.4486-.9993-.9997s.4482-.9993.9993-.9993c.5511 0 .9993.4482.9993.9993.0004.5511-.4482.9997-.9993.9997m-11.046 0c-.5511 0-.9993-.4486-.9993-.9997s.4482-.9993.9993-.9993c.5511 0 .9993.4482.9993.9993.0004.5511-.4482.9997-.9993.9997m11.4045-6.02l1.9973-3.4592a.416.416 0 00-.1521-.5676.416.416 0 00-.5676.1521l-2.0223 3.503C15.5902 8.2439 13.8533 7.8508 12 7.8508s-3.5902.3931-5.1367 1.0989L4.841 5.4467a.4161.4161 0 00-.5677-.1521.4157.4157 0 00-.1521.5676l1.9973 3.4592C2.6889 11.1867.3432 14.6589 0 18.761h24c-.3435-4.1021-2.6892-7.5743-6.1185-9.4396" />
              </svg>
              Descargar APK
            </a>
            <p className="text-xs text-blue-200 mt-3">
              Compatible con Android 5.0+ · 58 MB
            </p>
          </div>

          {/* Derecha: Mockup (simulado) */}
          <div className="flex justify-center">
            <div className="w-full max-w-sm bg-white rounded-[2rem] shadow-2xl overflow-hidden border-8 border-slate-800">
              <div className="bg-slate-900 h-6 flex justify-center items-center">
                <div className="w-16 h-3 bg-slate-700 rounded-full"></div>
              </div>
              <div className="p-6 bg-slate-50 text-slate-800">
                <div className="text-center mb-4">
                  <div className="text-4xl mb-2">🦐</div>
                  <div className="text-sm font-bold text-blue-900">
                    Gestiona tu finca
                  </div>
                  <div className="text-[11px] text-slate-500 mt-1">
                    Todo en una sola app
                  </div>
                </div>
                <div className="space-y-2">
                  {[
                    { i: '🗺️', t: 'Mapeo' },
                    { i: '📋', t: 'Actividades' },
                    { i: '🧪', t: 'Muestreo' },
                    { i: '💧', t: 'Parámetros' },
                    { i: '📈', t: 'Gráficas' },
                  ].map((m) => (
                    <div key={m.t} className="flex items-center gap-3 p-2 bg-white rounded-lg shadow-sm">
                      <div className="w-8 h-8 rounded bg-blue-100 flex items-center justify-center text-base">
                        {m.i}
                      </div>
                      <div className="text-xs font-semibold text-slate-700">{m.t}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA inferior */}
        <div className="mt-16 text-center border-t border-white/10 pt-12">
          <h2 className="text-2xl font-bold mb-3">
            ¿Quieres probarla antes de pagar?
          </h2>
          <p className="text-blue-100 text-sm mb-6">
            Crea tu cuenta gratis y accede al panel web durante 7 días.
          </p>
          <button
            onClick={() => navigate('/login')}
            className="px-8 py-3 bg-gradient-to-r from-amber-500 to-orange-500 rounded-xl font-bold shadow-xl hover:from-amber-600 hover:to-orange-600 transition"
          >
            ✨ Prueba 7 días gratis
          </button>
        </div>
      </div>

      {/* Footer */}
      <footer className="text-center py-6 text-xs text-blue-200/60 border-t border-white/10">
        © 2026 Lluchunga Technology · Todos los derechos reservados
      </footer>
    </div>
  );
}